export default __webpack_public_path__ + "static/media/img-wallet-nofunds.bed54150.svg";